import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { UserRoleService } from '../services';
import { BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Directive({
  // tslint:disable-next-line:directives-selector
  selector: '[grantBiddingAccess]'
})
export class GrantBiddingAccessDirective implements OnInit, OnDestroy {
  destroy$ = new Subject();
  onlyIf$ = new BehaviorSubject(true);
  private isInitialized$: Subject<boolean> = new Subject();
  private displayed = false;

  @Input() grantBiddingAccessInvert = false;

  @Input()
  set grantBiddingAccessOnlyIf(value: boolean) {
    this.onlyIf$.next(value);
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userRoleService: UserRoleService,
  ) {}

  ngOnInit(): void {
    const hasAccess = this.grantBiddingAccessInvert
      ? !this.userRoleService.hasBiddingTemplate()
      : this.userRoleService.hasBiddingTemplate();

    combineLatest([
      new BehaviorSubject(hasAccess),
      this.onlyIf$,
      this.isInitialized$,
    ]).pipe(
      takeUntil(this.destroy$),
      filter(([_, __, isInitialized]) => isInitialized),
    ).subscribe(([access, onlyIf]) => {
      if (access && onlyIf && !this.displayed) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.displayed = true;
      } else if (this.displayed && (!access || !onlyIf)) {
        this.viewContainer.clear();
        this.displayed = false;
      }
    });
    this.isInitialized$.next(true);
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
  }
}
